import React, { memo } from 'react';
import PageHeader from '../components/layout/PageHeader';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { CalendarIcon, ArrowRightIcon, UserIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const AnniversaryNews = () => {
  const newsItems = [{
    id: 1,
    title: '70th Anniversary Planning Committee Inaugurated',
    date: 'February 10, 2025',
    author: 'ISOGRAS National Exco',
    excerpt: 'The National Executive Council of ISOGRAS has officially inaugurated the central planning committee for the upcoming 70th Anniversary celebrations. The committee is tasked with organizing a memorable week-long event.',
    image: 'https://cdn.magicpatterns.com/uploads/keQ1z5dAhNMgYe2HztvvFc/WhatsApp_Image_2026-02-19_at_14.06.18.jpg'
  }, {
    id: 2,
    title: 'Call for Legacy Project Donations',
    date: 'January 25, 2025',
    author: 'Anniversary Committee',
    excerpt: 'As part of the 70th Anniversary, the school management and alumni association have identified key infrastructure projects. We are calling on all sets and well-meaning individuals to support these initiatives.',
    image: 'https://cdn.magicpatterns.com/uploads/4BLAurHpHDTJys8pMyfP5D/WhatsApp_Image_2026-02-19_at_14.10.23.jpg'
  }, {
    id: 3,
    title: 'Golden Gateway Set (1973-1977) Announces Special Endowment',
    date: 'January 15, 2025',
    author: 'Alumni News',
    excerpt: 'The 1973-1977 set has announced a special scholarship endowment fund to be launched during the 70th Anniversary. This fund will support outstanding students in science and technology.',
    image: 'https://cdn.magicpatterns.com/uploads/qNUMAPwjKxXJgQ7Cmi46du/WhatsApp_Image_2026-02-19_at_14.10.24_(1).jpg'
  }, {
    id: 4,
    title: 'Anniversary Souvenirs Now Available for Pre-order',
    date: 'December 5, 2024',
    author: 'Merchandise Sub-committee',
    excerpt: 'Official 70th Anniversary merchandise, including polo shirts, caps, lapel pins, and commemorative brochures, are now available for pre-order. Secure yours early!',
    image: 'https://cdn.magicpatterns.com/uploads/c7E6gNvjj8RSkSzE9h2iVJ/70th_Anniversary_logo.jpg'
  }, {
    id: 5,
    title: 'Students Rally for the 70th Anniversary Celebrations',
    date: 'February 19, 2026',
    author: 'School Administration',
    excerpt: 'Current students of Isonyin Grammar School gathered on campus in their iconic blue uniforms to show their excitement and support for the upcoming 70th Anniversary celebrations.',
    image: 'https://cdn.magicpatterns.com/uploads/xpARZk6EqGjvu9VViCYM9y/WhatsApp_Image_2026-02-19_at_14.10.25_(1).jpg'
  }, {
    id: 6,
    title: 'Campus Preparations in Full Swing',
    date: 'February 18, 2026',
    author: 'Anniversary Committee',
    excerpt: 'With just weeks to go, the school campus is buzzing with activity as students and staff prepare for the grand celebration. Classroom blocks and grounds are being spruced up for the big week.',
    image: 'https://cdn.magicpatterns.com/uploads/sy2fp2k6vQ2gmvVmHC3E1e/WhatsApp_Image_2026-02-19_at_14.10.24.jpg'
  }];
  return <div className="min-h-screen bg-gray-50" data-id="element-3944">
      <PageHeader title="Anniversary News & Updates" description="Stay informed about the latest preparations, announcements, and activities leading up to our 70th Anniversary." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: '70th Anniversary',
      path: '/anniversary'
    }, {
      label: 'News',
      path: '/anniversary-news'
    }]} data-id="element-3945" />

      <div className="container mx-auto px-4 py-16" data-id="element-3946">
        <div className="max-w-5xl mx-auto" data-id="element-3947">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3948">
            {newsItems.map(item => <Card key={item.id} hover padding="none" className="overflow-hidden flex flex-col h-full" data-id="element-3949">
                <div className="h-48 overflow-hidden relative" data-id="element-3950">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" data-id="element-3951" />
                  <div className="absolute top-4 right-4 bg-yellow-500 text-blue-900 text-xs font-bold px-3 py-1 rounded-full shadow-md" data-id="element-3952">
                    Update
                  </div>
                </div>
                <div className="p-6 flex-grow flex flex-col" data-id="element-3953">
                  <div className="flex items-center text-sm text-gray-500 mb-3 space-x-4" data-id="element-3954">
                    <span className="flex items-center" data-id="element-3955">
                      <CalendarIcon className="h-4 w-4 mr-1" data-id="element-3956" /> {item.date}
                    </span>
                    <span className="flex items-center" data-id="element-3957">
                      <UserIcon className="h-4 w-4 mr-1" data-id="element-3958" /> {item.author}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-blue-900 mb-3 line-clamp-2" data-id="element-3959">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 mb-6 flex-grow line-clamp-3" data-id="element-3960">
                    {item.excerpt}
                  </p>
                  <div className="mt-auto" data-id="element-3961">
                    <Link to="#" className="inline-flex items-center text-blue-700 font-medium hover:text-blue-900 transition-colors" data-id="element-3962">
                      Read Full Update{' '}
                      <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-3963" />
                    </Link>
                  </div>
                </div>
              </Card>)}
          </div>

          <div className="mt-12 text-center" data-id="element-3964">
            <Button variant="outline" className="border-blue-900 text-blue-900 hover:bg-blue-50" data-id="element-3965">
              Load More Updates
            </Button>
          </div>
        </div>
      </div>
    </div>;
};
export default AnniversaryNews;